import SwitchModule from './switch.module'

export default SwitchModule
